import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {setLookCompatabilityAlert} from "../../../../../actions/lookFunctions";


const LookCompatabilitySectionButtons = (props) => {

  const {lookCompatabilityAlert, setLookCompatabilityAlert} = props;

  const closeAlert = () => {
    setLookCompatabilityAlert({
      visible: false,
      compatabilityLogic: [],
      clickedFeature: null,
      applyFunction: null
    })
  }

  const closeAlertClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookCloseCompatabilityAlert);
    closeAlert()
  };

  const updateDesignButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookCloseAndApplyCompatabilityAlert);
    if (lookCompatabilityAlert.applyFunction) { // just in case
      // const sinkToApply = lookCompatabilityAlert.compatabilityLogic[0].from;
      lookCompatabilityAlert.applyFunction()
    }
    closeAlert();  // then remove the view
  }

  //console.log("availableFilters", availableFilters);

  return (
    <div className={"look-popup__buttons"}>
      <Button className={"look-button look-button--secondary look-button--min look-button--no-transform"}
              onClick={closeAlertClick}>
        <FormattedMessage id="buttons.cancel"/>
      </Button>
      <Button className={"look-button look-button--primary look-button--min look-button--no-transform"}
              onClick={updateDesignButtonClick}>
        <FormattedMessage id="buttons.update"/>
      </Button>
    </div>
  )
};

LookCompatabilitySectionButtons.propTypes = {
  wrapperStyles: PropTypes.object
}

const mapStateToProps = (store) => {
  const {lookCompatabilityAlert, lookActiveFeature} = store.lookState;
  return {
    lookActiveFeature,
    lookCompatabilityAlert,
  };
};

const mapDispatchToProps = {
  setLookCompatabilityAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookCompatabilitySectionButtons)
